module.exports = __webpack_public_path__ + "img/18_75.31e7940b.png";